import styled from "styled-components";

export const CarouselWrapper = styled.div<{ showArrows: boolean; padding: number; centerWhenFewItems?: boolean }>`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 0 ${(props) => props.padding}px;
  margin: 0 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: ${(props) => (props.centerWhenFewItems ? "center" : "flex-start")};
`;

export const CarouselInner = styled.div<{ translateX: number; center?: boolean }>`
  display: flex;
  transition: transform 0.3s ease-in-out;
  transform: translateX(${(props) => props.translateX}px);
  justify-content: ${(props) => (props.center ? "center" : "flex-start")};
`;

export const Item = styled.div<{ gap: number }>`
  flex: 0 0 auto;
  margin: 0 ${(props) => props.gap / 2}px;
`;

export const ArrowButton = styled.button<{ position: "left" | "right"; visible: boolean; buttonSize: number }>`
  position: absolute;
  top: 50%;
  ${(props) => (props.position === "left" ? "left: 0;" : "right: 0;")}
  transform: translateY(-50%);
  background: #fff;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  z-index: 5;
  width: ${(props) => props.buttonSize}px;
  height: ${(props) => props.buttonSize}px;
  display: ${(props) => (props.visible ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  margin: 0 2px;

  &:hover {
    background: #f0f0f0;
  }

  svg {
    font-size: 18px;
    color: #333;
  }
`;